import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	loading: false,
	error: null,
};

export const productSlice = createSlice({
    name: 'product',
    initialState,

    reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
        // 제품 조회
        fetchProductListRequest: (state) => {
			state.loading = true;
        },
        fetchProductListSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload.data;
			state.error = null;
        },
        fetchProductListFailure: (state) => {
			state.loading = false;
			state.data = [];
			state.error = true;
        },
    },
});

export const {
    setLoading,
    fetchProductListRequest,
    fetchProductListSuccess,
    fetchProductListFailure
} = productSlice.actions;

export default productSlice.reducer;